import React, { useState } from 'react';

const ModalConfirmarRecurrente = ({
  show,
  onClose,
  onConfirm,
  cita,
  loading = false
}) => {
  const [opcion, setOpcion] = useState('esta');

  if (!show || !cita) return null;

  const handleConfirm = () => {
    onConfirm(opcion);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '450px', borderRadius: '16px', overflow: 'hidden' }}
      >
        <div style={{
          background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
          padding: '1.25rem 1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <span style={{ fontSize: '1.4rem' }}>⚠️</span>
            <h3 style={{ margin: 0, color: 'white', fontSize: '1.1rem', fontWeight: '700' }}>
              Cancelar Cita
            </h3>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              width: '28px',
              height: '28px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            ✕
          </button>
        </div>

        <div className="modal-body">
          <div style={{
            padding: '1rem',
            backgroundColor: '#fef3c7',
            borderRadius: '8px',
            marginBottom: '1.5rem',
            border: '1px solid #fcd34d'
          }}>
            <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.9rem', color: '#92400e' }}>
              Cita recurrente
            </p>
            <p style={{ margin: 0, fontWeight: '600', color: '#78350f' }}>
              {cita.cliente_nombre || 'Cliente'}
            </p>
            <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.9rem', color: '#92400e' }}>
              {new Date(cita.fecha_cita).toLocaleDateString('es-ES')} a las {cita.hora_inicio}
            </p>
          </div>

          <p style={{ color: '#374151', marginBottom: '1.5rem', fontWeight: '500' }}>
            ¿Qué deseas hacer con esta cita recurrente?
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '1.5rem' }}>
            <label style={{
              padding: '1rem',
              border: opcion === 'esta' ? '2px solid #f59e0b' : '1px solid #e5e7eb',
              borderRadius: '8px',
              backgroundColor: opcion === 'esta' ? '#fef3c7' : '#f9fafb',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}>
              <input
                type="radio"
                name="opcion"
                value="esta"
                checked={opcion === 'esta'}
                onChange={(e) => setOpcion(e.target.value)}
                style={{ marginRight: '0.5rem' }}
                disabled={loading}
              />
              <span style={{ fontWeight: '600', color: '#374151' }}>
                Cancelar solo esta cita
              </span>
              <p style={{ margin: '0.25rem 0 0 1.5rem', fontSize: '0.9rem', color: '#6b7280' }}>
                Las demás citas de la serie continuarán normalmente
              </p>
            </label>

            <label style={{
              padding: '1rem',
              border: opcion === 'todas' ? '2px solid #f59e0b' : '1px solid #e5e7eb',
              borderRadius: '8px',
              backgroundColor: opcion === 'todas' ? '#fef3c7' : '#f9fafb',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}>
              <input
                type="radio"
                name="opcion"
                value="todas"
                checked={opcion === 'todas'}
                onChange={(e) => setOpcion(e.target.value)}
                style={{ marginRight: '0.5rem' }}
                disabled={loading}
              />
              <span style={{ fontWeight: '600', color: '#374151' }}>
                Cancelar toda la serie
              </span>
              <p style={{ margin: '0.25rem 0 0 1.5rem', fontSize: '0.9rem', color: '#6b7280' }}>
                Se cancelarán todas las citas restantes de esta serie
              </p>
            </label>
          </div>

          <div className="modal-footer">
            <button
              onClick={onClose}
              className="btn btn-secondary"
              disabled={loading}
            >
              Atrás
            </button>
            <button
              onClick={handleConfirm}
              style={{
                backgroundColor: '#f59e0b',
                color: 'white',
                border: 'none',
                padding: '0.75rem 1.5rem',
                borderRadius: '8px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              disabled={loading}
              onMouseOver={(e) => e.target.style.opacity = '0.8'}
              onMouseOut={(e) => e.target.style.opacity = '1'}
            >
              {loading ? 'Cancelando...' : 'Cancelar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmarRecurrente;
